"use client";
import React, { useState } from "react";
import styles from "./PurchaseSuccessNotification.module.css";
import dayjs from "dayjs";

export interface PurchaseSuccessNotificationProps {
  session: {
    duration: number;
    slot: string;
  };
  mentor: {
    name: string;
    avatar_url: string;
  };
}

const PurchaseSuccessNotification = ({
  session,
  mentor,
  createAccount,
}: PurchaseSuccessNotificationProps & {
  createAccount: () => void;
}) => {
  const formatDateTime = (datetime: string) => {
    const day = dayjs(datetime);
    return day.format("ddd MMM D h:mma z");
  };

  return (
    <>
      <div className={styles.modal_backdrop} />
      <div
        data-testid="purchase_success_notification"
        className={styles.container}
      >
        <div className={styles.mentor}>
          <img src={mentor.avatar_url} className={styles.avatar_image} />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            className={styles.mentor_tick_icon}
          >
            <rect width="24" height="24" rx="12" fill="#1A1C1D" />
            <circle cx="12.5" cy="12.5" r="7.5" fill="white" />
            <path
              d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.0026 16L18.0737 8.92893L16.6595 7.51472L11.0026 13.1716L8.17421 10.3431L6.75999 11.7574L11.0026 16Z"
              fill="#15B881"
            />
          </svg>
          <div className={styles.mentor_info}>
            <h3>{mentor.name}</h3>
            <div className={styles.details_container}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7.99967 14.6667C4.31777 14.6667 1.33301 11.6819 1.33301 8.00004C1.33301 4.31814 4.31777 1.33337 7.99967 1.33337C11.6815 1.33337 14.6663 4.31814 14.6663 8.00004C14.6663 11.6819 11.6815 14.6667 7.99967 14.6667ZM7.99967 13.3334C10.9452 13.3334 13.333 10.9456 13.333 8.00004C13.333 5.05452 10.9452 2.66671 7.99967 2.66671C5.05415 2.66671 2.66634 5.05452 2.66634 8.00004C2.66634 10.9456 5.05415 13.3334 7.99967 13.3334ZM8.66634 8.00004H11.333V9.33337H7.33301V4.66671H8.66634V8.00004Z"
                  fill="#BFBFBF"
                />
              </svg>
              <p>
                {session.duration} min with {mentor.name}
              </p>
            </div>
            <div className={styles.details_container}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M5.99967 0.666626V1.99996H9.99967V0.666626H11.333V1.99996H13.9997C14.3679 1.99996 14.6663 2.29844 14.6663 2.66663V13.3333C14.6663 13.7015 14.3679 14 13.9997 14H1.99967C1.63149 14 1.33301 13.7015 1.33301 13.3333V2.66663C1.33301 2.29844 1.63149 1.99996 1.99967 1.99996H4.66634V0.666626H5.99967ZM13.333 7.33329H2.66634V12.6666H13.333V7.33329ZM4.66634 3.33329H2.66634V5.99996H13.333V3.33329H11.333V4.66663H9.99967V3.33329H5.99967V4.66663H4.66634V3.33329Z"
                  fill="#BFBFBF"
                />
              </svg>
              <p>{formatDateTime(session.slot)}</p>
            </div>
          </div>
        </div>
        <div className={styles.main_content}>
          <h2>
            Payment successful! Create an account now so you can join your call.
          </h2>
          <p>
            You <span className={styles.alert}>MUST</span> complete this now to
            avoid problems when joining your session.
          </p>
        </div>
        <button data-testid={"create_account_button"} onClick={createAccount}>
          Create Account
        </button>
      </div>
    </>
  );
};

export default PurchaseSuccessNotification;
